// language=GraphQL
export const ALL_BOOKING_ADDONS_QUERY = `query Query($withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
  bookingAddons: ratioBookingAddons {
    id
    ratioServiceNo
    name
    label
    info
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_BOOKING_ADDON_QUERY = `query Query($id: ID!, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
  bookingAddon: ratioBookingAddon(id: $id) {
    id
    ratioServiceNo
    name
    label
    info
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_BOOKING_ADDON_MUTATION = `
  mutation Mutation($input: CreateRatioBookingAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
    bookingAddon: createRatioBookingAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_BOOKING_ADDON_MUTATION = `
  mutation Mutation($input: UpdateRatioBookingAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
    bookingAddon: updateRatioBookingAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_BOOKING_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioBookingAddonInput) {
    deleteRatioBookingAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BOOKING_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioBookingAddonInput) {
    forceDeleteRatioBookingAddon(input: $input) {
      success
    }
  }`
// language=GraphQL
export const BOOKING_ADDONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {
  groupedDependents: ratioBookingAddonDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
  }
}`
